import * as React from 'react';
import moment from "moment";
import {DateRange} from "../../common/dtos";
import {calendarMinuteStep} from "../calendar-utils";

interface EmptyViewProps {
  time: moment.Moment;
  onClick: (timeRange: DateRange) => void;
}

class EmptyView extends React.Component<EmptyViewProps, {}> {

  constructor(props: EmptyViewProps) {
    super(props);
    this.state = {}
  }

  public render(): React.ReactNode {
    return (
      <div
        className="calendar-empty-view"
        onClick={this.onClick}
      />
    );
  }

  private onClick = () => {
    const {time, onClick} = this.props;
    const timeRange: DateRange = {
      start: time.clone(),
      end: time.clone().add(calendarMinuteStep, 'minutes'),
    }
    onClick(timeRange);
  }
}

export default EmptyView;


// WEBPACK FOOTER //
// ./src/event/view/EmptyView.tsx